// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warehouse-select>span[data-v-02842a0b]{\n    width: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
